/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Statep21Inputs */



/**
* | output |
* | --- |
* | "Right/low pump state" |
*
* @param {Br_History_Key_Statep21Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_statep21 = /** @type {((inputs?: Br_History_Key_Statep21Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Statep21Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Right/low pump state")
	return /** @type {LocalizedString} */ ("Etat pompe droite/basse")
});
export { br_history_key_statep21 as "br_history_key_stateP2" }